<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li>{{ $t("gift.management") }}</li>
            <li>{{ $t("gift.request") }}</li>
          </ul>
        </nav>
      </div>
      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left">
            <span> {{ $t("gift.request") }} </span>
          </h2>
        </div>
        <div class="section-header-right">
          <a class="btn btn-default dropdown-arrow text-white" uk-toggle="target: #shareSettings" uk-tooltip=""
          > {{ $t('general.gift_approve_settings') }}
          </a>
        </div>

        <div id="shareSettings" class="uk-modal" uk-modal>
          <div class="uk-modal-dialog bggray">
            <div class="uk-padding-small" uk-grid>
              <h4> {{ $t('general.gift_approve_settings') }} </h4>
            </div>
            <div class="row p-4">
              <div class="col-lg-12">
                <div class="form-group row mb-2">
                  <label class="col-md-6 col-form-label" for="website_keywords">
                    {{ $t('general.no_approval_required') }}
                    <i aria-expanded="false" class="uil-info-circle"
                       :title="$t('general.gift_approval_required_info')" uk-tooltip></i></label>
                  <div class="col-md-6">
                    <label class="uk-switch" for="default-1">
                      <input id="default-1" v-model="gift_approval_required" type="checkbox"
                             @change="handleGiftSettings"/>
                      <div class="uk-switch-slider"></div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-modal-footer uk-text-right bggray">
              <button class="uk-button uk-button-default small uk-modal-close" type="button">
                <i class="uil-times"></i> {{ $t("general.close") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>
      <div class="card">
        <!-- Card header -->
        <div class="card-header actions-toolbar border-0">
          <div class="d-flex justify-content-between align-items-center">
            <div class="row" style="width: 100%">
              <div class=" col-md-1  search-icon ">
                <i class="uil-search"></i>
              </div>
              <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
                <input v-model="filter.search" :placeholder="$t('general.search')" class="uk-search-input shadow-0 uk-form-small "
                       type="search"/>
              </div>
            </div>
            <div class="d-flex">
              <!-- Shorting -->
              <a :uk-tooltip="$t('general.sort_list')" aria-expanded="false" class="btn btn-icon btn-hover btn-circle" href="#"
                 title="">
                <i class="uil-list-ui-alt"></i>
              </a>
              <div class="uk-dropdown" uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
                <ul class="uk-nav uk-dropdown-nav">
                  <li @click="sortOrder('name', 'asc')">
                    <a href="javascript:void(0)">{{ $t("sorting.a_z") }}</a>
                  </li>
                  <li @click="sortOrder('name', 'desc')">
                    <a href="javascript:void(0)">{{ $t("sorting.z_a") }}</a>
                  </li>
                  <li @click="sortOrder('point', 'asc')">
                    <a href="javascript:void(0)">
                      {{ $t("gift.filter.highest_point") }}</a>
                  </li>
                  <li @click="sortOrder('point', 'desc')">
                    <a href="javascript:void(0)">
                      {{ $t("gift.filter.lowest_point") }}</a>
                  </li>
                </ul>
              </div>
            </div>

            <excel-download-button :loading="isReportDownloading" :tooltipText="$t('filters.export_excell')" @download="exportUsers" />

          </div>
        </div>
        <!-- Table -->
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
            <tr>
              <th scope="col">{{ $t("users.user") }}</th>
              <th scope="col">{{ $t("gift.name") }}</th>
              <th scope="col">{{ $t("point.coin") }}</th>
              <th scope="col">{{ $t("general.added_at") }}</th>
              <th scope="col">{{ $t("point.stock_quantity") }}</th>
              <th scope="col">{{ $t("general.status") }}</th>
              <th scope="col"></th>
            </tr>
            </thead>
            <tbody class="list">
            <!--user item-->
            <tr v-for="item in formattedGiftHistories">
              <th scope="row">
                <div class="media align-items-center">
                  <div>
                    <div class="avatar-parent-child" style="width: max-content">
                      <AvatarOrIcon :size-px="32" :src="item.user_image"/>
                      <span class="avatar-child avatar-badge bg-success"></span>
                    </div>
                  </div>
                  <div class="media-body ml-4">
                    <a class="name h6 mb-0 text-sm disabled">{{
                        item.user_name
                      }}</a>
                    <small class="d-block font-weight-bold">#{{ item.user_id }}</small>
                  </div>
                </div>
              </th>
              <th scope="row">
                <div class="media align-items-center">
                  <div>
                    <div class="avatar-parent-child">
                      <img :src="item.image" class="avatar"/>
                    </div>
                  </div>
                  <div class="media-body ml-4">
                    <!-- <router-link
                    :to="{ name: 'company.gift.add' }"
                    class="name h6 mb-0 text-sm"
                  >
                    {{ item.name }}
                  </router-link> -->
                    {{ item.name }}
                  </div>
                </div>
              </th>
              <td>{{ item.point }}</td>
              <td>{{ item.created_at }}</td>
              <td style="text-align: center;">{{ item.last_quantity }}</td>
              <td v-if="item.status_id === 0">{{$t('general.rejected')}}</td>
              <td v-if="item.status_id === 1">{{$t('general.pending')}}</td>
              <td v-if="item.status_id === 2">{{$t('general.approved')}}</td>
              <td class="text-right">
                <div class="actions ml-3">
                  <a v-if="item.gift_address_required" class="btn btn-icon btn-hover btn-sm btn-circle"
                     :uk-tooltip="$t('general.detail')" @click="setModal(item.address)">
                    <i class="uil-info-circle text-info"></i>
                  </a>

                  <!-- Animasyonlu 3 nokta -->
                  <template v-if="processingItemId === item.id">
                    <ProcessingDots :tooltip-text="$t('general.processing')" />
                  </template>

                  <!-- Onayla/Reddet butonları -->
                  <template v-else>
                    <a :class="{ 'disabled': (item.status_id === 2 || item.last_quantity <= 0 || processingItemId !== null) }"
                       :uk-tooltip="$t('general.approve')"
                       class="btn btn-icon btn-hover btn-sm btn-circle"
                       href="javascript:void(0)"
                       @click="processingItemId === null && approveOrReject(item.id, 2)">
                      <i class="uil-check-circle text-success"></i>
                    </a>

                    <a :class="{ 'disabled': (item.status_id === 0 || processingItemId !== null) }"
                       :uk-tooltip="$t('general.reject')"
                       aria-expanded="false"
                       class="btn btn-icon btn-hover btn-sm btn-circle"
                       href="javascript:void(0)"
                       @click="processingItemId === null && approveOrReject(item.id, 0)">
                      <i class="uil-minus-circle text-danger"></i>
                    </a>
                  </template>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <pagination v-if="pagination" :pagination="pagination" @changePage="setPage($event)"></pagination>
    </div>
    <div id="giftRequestDetails" class="uk-modal" uk-modal>
      <div class="uk-modal-dialog bggray">
        <div class="uk-padding-small" uk-grid>
          <h4>{{ $t("general.gift_request_details") }}</h4>
          <div class="row">
            <div class="col-lg-12">
              <div class="form-group row mb-3">
                <label class="col-md-4 col-form-label" for="name">{{ $t("general.earned_in_education") }}</label>
                <div class="col-md-8">
                  <span id="name"> İş Güvenliği ve Sağlığı Eğitimi</span>
                </div>
              </div>

              <div class="form-group row mb-3">
                <label class="col-md-4 col-form-label" for="address">{{ $t("general.address") }}</label>
                <div class="col-md-8">
                  <span id="address">
                    Esentepe, Onur İş Merkezi, Müselles Sokak, Büyükdere Cd.
                    No:1, 34394 Şişli
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="uk-modal-footer uk-text-right bggray">
          <button class="uk-button uk-button-default small uk-modal-close" type="button">
            <i class="uil-times"></i> {{ $t("general.close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import store from "@/core/services";
import moment from "moment";
import Pagination from "@/assets/components/Pagination";
import AvatarOrIcon from "@/view/components/icons/AvatarOrIcon.vue";
import ProcessingDots from "@/view/components/loading/ProcessingDots.vue";
import { showSuccess, showError } from "@/utils/alertUtils";

import history_module, {
  BASE_URL,
  MODULE_NAME,
  ITEMS,
  GET_ITEMS,
  UPDATE_ITEM,
  ERROR,
} from "@/core/services/store/gift_history.module";
import company_module, {
  GET_ITEM as COMPANY_GET_ITEM,
  ITEM as COMPANY_ITEM,
  MODULE_NAME as COMPANY_MODULE_NAME,
} from "@/core/services/store/company.module";
import axios from "axios";
import ExcelDownloadButton from "@/view/components/buttons/ExcelDownloadButton.vue";

const _HISTORY_MODULE_NAME = MODULE_NAME;
const _COMPANY_MODULE_NAME = COMPANY_MODULE_NAME;

export default {
  name: "GiftList",
  components: { ExcelDownloadButton, DataTable, Pagination, AvatarOrIcon, ProcessingDots },
  data() {
    return {
      // status_id: 1,
      pagination: null,
      activeItem: null,
      successMessage: null,
      errorMessages: [],
      page: 1,
      per_page: 10,
      filter: {
        search: null,
        orderBy: "created_at",
        sort: "desc",
      },
      headers: this.apiHeaders,
      gift_approval_required: false,
      isReportDownloading: false,
      processingItemId: null, // tıklanan item ın id'si
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_HISTORY_MODULE_NAME, history_module);
    registerStoreModule(_COMPANY_MODULE_NAME, company_module);
  },
  computed: {
    gift_history: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEMS];
      },
      set(value) {
      },
    },
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    companyData: {
      get() {
        return store.getters[COMPANY_MODULE_NAME + "/" + COMPANY_ITEM];
      },
      set(value) {
      },
    },
    formattedGiftHistories() {
      let results = [];
      if (this.gift_history === null || !("data" in this.gift_history))
        return [];
      this.pagination = this.gift_history

      this.gift_history.data.forEach((currentItem) => {
        if (currentItem.user === undefined) return []
        results.push({
          user_name: currentItem.user?.name + " " + currentItem.user?.surname,
          user_image: currentItem.user?.photo_link,
          user_id: currentItem.user?.id,
          name: currentItem.name,
          image: currentItem.gift?.image_link,
          gift_address_required: currentItem.gift?.address_required,
          id: currentItem.id,
          point: currentItem.point,
          address: currentItem.address,
          created_at: currentItem.created_at
              ? moment(currentItem.created_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
          last_quantity: currentItem.gift?.stock_quantity > 0 ? currentItem.gift?.stock_quantity
              : 0,
          status: this.getStatusById(currentItem.status_id),
          status_id: currentItem.status_id,
        });
      });

      return results;
    },
  },
  methods: {
    async getGiftHistoryResult() {
      let self = this;
      await this.$store.dispatch(MODULE_NAME + "/" + GET_ITEMS, {
        url: BASE_URL,
        filters: {
          like: self.filter.search,
          page: self.page,
          per_page: self.per_page,
          sort: self.filter.sort,
          order_by: self.filter.orderBy,
          status_id: self.status_id,
          with_user: true,
        },
      });
    },
    setModal(address) {
      const addressSpan = $('#giftRequestDetails span#address');
      addressSpan.html(address);
      // Modal'ı programatik olarak aç
      UIkit.modal("#giftRequestDetails").show();
    },
    getStatusById(id) {
      switch (id) {
        case 0:
          return this.$t("general.passive");
        case 1:
          return this.$t("general.active");
        case 2:
          return this.$t("general.approved");
        default:
          return "";
      }
    },
    async approveOrReject(id, status_id) {
      this.processingItemId = id;

      try {
        const response = await this.$store.dispatch(MODULE_NAME + "/" + UPDATE_ITEM, {
          url: BASE_URL + "/" + id + "/update-status",
          contents: { status_id: status_id }
        });

        // Başarılı - response.data.id varsa
        if (response?.data?.id) {
          showSuccess(this.$t("general.successfully_updated"));
          await this.getGiftHistoryResult();
          this.$forceUpdate();
        } else {
          // Hatalı - response.data.message varsa
          const errorMessage = response?.data?.message || 'general.error_occurred';
          showError(this.$t(errorMessage));
        }
      } catch (error) {
        // 500 hatası veya network hatası
        // error.response.data.message backend'den gelen hata mesajı
        const errorMessage = error?.response?.data?.message || 'general.error_occurred';
        showError(this.$t(errorMessage));
      } finally {
        this.processingItemId = null;
      }
    },
    sortOrder(orderBy, sort) {
      let self = this;
      self.page = 1;
      self.filter.orderBy = orderBy;
      self.filter.sort = sort;

      this.getGiftHistoryResult();
    },
    setPage(page) {
      let self = this;
      self.page = page;
      this.getGiftHistoryResult();
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
    getCompanyItem() {
      this.$store.dispatch(COMPANY_MODULE_NAME + "/" + COMPANY_GET_ITEM, {
        url: "api/company/self",
      }).then((response) => {

        if (response && response.gift_approval_required !== undefined) {
          this.gift_approval_required = response.gift_approval_required;
        }
      });
    },
    async handleGiftSettings() {
      if (!this.companyData || !this.companyData.id) {
        showError(this.$t('errors.error_occurred'));
        return;
      }

      try {
        const form = { gift_approval_required: this.gift_approval_required ? true : false };

        await axios.post(
            `api/company/update-settings/${this.companyData.id}`,
            form
        );

        showSuccess(this.$t('general.successfully_updated'));
      } catch (error) {
        console.error('Gift settings update error:', error);
        showError(
            error.response?.data?.message || this.$t('errors.error_occurred')
        );

        // Hata durumunda toggle'ı eski haline getir
        this.gift_approval_required = !this.gift_approval_required;
      }
    },
    exportUsers() {
      if (this.isReportDownloading) {
        return;
      }
      this.isReportDownloading = true;

      let config = {
        responseType: "blob"
      };

      axios.get(process.env.VUE_APP_BACKEND_APP_URL + '/api/report/export/gift-history'+"?report=" + Math.random() * 9999999, config)
          .then((response) => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            let day = moment().format("YYYYMMDDHHMMSS");
            let fileName = "users_list_" + day + ".xlsx";
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);
            fileLink.click();

            this.isReportDownloading = false;
          })
          .catch(() => {
            this.isReportDownloading = false;
          });
    },
  },
  mounted() {
    if (!this.$isGiftVisible) {
      this.$router.push({ name: 'company.dashboard' })
    }
    this.getCompanyItem();
    this.getGiftHistoryResult();
  },
  beforeDestroy() {
    const modal = UIkit.modal("#giftRequestDetails");
    if (modal) modal.$destroy(true);
  },
  watch: {
    "filter.search": function (val) {
      this.debouncedFilterSearch();
    },
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    errorMessages: function (val) {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedFilterSearch = _.debounce(this.getGiftHistoryResult, 500);
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
};
</script>
<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}
</style>
